import { MultiCallABI } from '../constants';
import { useMulticallAddress } from './useMulticallAddress';
import { useCall } from './useCall';
import { Contract } from 'ethers';
/**
 * @public
 */
export function useEtherBalance(address, queryParams = {}) {
    var _a;
    const multicallAddress = useMulticallAddress(queryParams);
    const { value: value } = (_a = useCall(multicallAddress &&
        address && {
        contract: new Contract(multicallAddress, MultiCallABI),
        method: 'getEthBalance',
        args: [address],
    }, queryParams)) !== null && _a !== void 0 ? _a : {};
    return value === null || value === void 0 ? void 0 : value[0];
}
//# sourceMappingURL=useEtherBalance.js.map